export default __webpack_public_path__ + "src/images/home/comunity_screen-b871ed08e5805598d05cc69662b002eb.png";